/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Card, CardContent, CardTitlePrimary, Grid, Message } from '@design-system-coopeuch/web';
import { stepperAction } from '../../../../application/actions/stepper';
import { Wrapper } from './styles';
import { properties } from '../../../../utils/properties';
import sello from '../../../assets/img/icon/Sello-Coopeuch.svg';
import { capitalizeEachWord } from '../../../../utils';
import iconDownload from '../../../assets/img/icon/icon-download.svg';
import BotonComprobante from '../BotonComprobante';
import Screenshot from '../../../../utils/Screenshot';
import { Fechas } from '../../../../utils/Fechas';
import iconStar from '../../../assets/img/icon/icon-star-empty-red.svg';
import ModalEncuestaSatisfaccion from '../../organisms/ModalEncuestaSatisfaccion';
import ModalRespuestaEncuesta from '../../organisms/ModalRespuestaEncuesta';

const Comprobante = ({ data, activeMenu, fechaCreacion, email, obtieneScreenshot }) => {
  const [tipoRespuesta, setTipoRespuesta] = useState('');
  const [openModalEncuestaSatisfaccion, setOpenModalEncuestaSatisfaccion] = useState(false);
  const [openModalRespuestaEncuesta, setOpenModalRespuestaEncuesta] = useState(false);
  const [encuestaRespondida, setEncuestaRespondida] = useState(false); // pendiente backend

  const dispatch = useDispatch();
  const {
    fechaRetiro,
    sucursal: { direccion, horario, sucursalName },
  } = data;

  useEffect(() => {
    dispatch(stepperAction.fetchStepper(activeMenu));
  }, [activeMenu]);

  const volverACoopeuch = () => {
    window.location.href = properties.urlCoopeuch;
  }

  const retomarEncuesta = () => {
    setOpenModalEncuestaSatisfaccion(true);
    setOpenModalRespuestaEncuesta(false);
  }

  return (
    <>
      <Wrapper>
        <Card>
          <div className="dato-comprobante-header">
            <Grid className="row py-4 border-bottom border-neutral-20 ml-0 px-row">
              <Grid className="col-6 py-1 px-0">
                <section className="d-flex flex-column flex-md-row align-items-start align-items-md-center flex-wrap">
                  <h3 className="title-content mb-1">
                    {properties.comprobante.comprobante.titulo}
                  </h3>
                </section>
                <p>{properties.comprobante.comprobante.subtitulo}</p>
              </Grid>
              <Grid className="col-4 d-flex align-middle justify-content-end">
                {process.env.REACT_APP_HABILITAR_ENCUESTAS === 'true' &&
                  <BotonComprobante
                    icon={iconStar}
                    handleClick={() => setOpenModalEncuestaSatisfaccion(!openModalEncuestaSatisfaccion)}
                    text="Danos tu opinión"
                  />}
              </Grid>
              <Grid className="col-2 d-flex align-middle justify-content-end">
                <BotonComprobante
                  icon={iconDownload}
                  handleClick={() => obtieneScreenshot()}
                  text="Descargar"
                />
              </Grid>
            </Grid>
          </div>
          <div className="datoComprobante">
            <CardTitlePrimary
              title={properties.comprobante.sucursal.titulo}
              subtitle={capitalizeEachWord(`${direccion}, ${sucursalName}`)}
            />
            <CardTitlePrimary
              title={properties.comprobante.fecha.titulo}
              subtitle={`Desde el ${fechaRetiro}`}
            />
          </div>
          <CardContent>
            <div className="horario">
              <p className="titulo">{properties.comprobante.fechaSucursal.titulo}</p>
              <p className="dato">{horario.substr(0, horario.indexOf('Viernes'))}</p>
              <p className="dato">{horario.substr(horario.indexOf('Viernes'))}</p>
            </div>
            <div className="sello">
              <img src={sello} alt="sello" />
              <p>{properties.selloCoopeuch.texto}</p>
            </div>
            <div className="footer">
              <hr />
              <p>
                {properties.comprobante.footer.texto}
                <b>{email}</b>
              </p>
              <p>
                {properties.comprobante.footer.texto2}
                <b>{fechaCreacion}</b>
              </p>
            </div>
          </CardContent>
        </Card>
        <div className="mensajeInfo">
          <Message
            description={properties.comprobante.Mensaje.texto2(Fechas.diasDesdeRetiro, fechaRetiro)}
            type="info"
          />
        </div>
      </Wrapper>
      {openModalEncuestaSatisfaccion && (
        <ModalEncuestaSatisfaccion
          setTipoRespuesta={setTipoRespuesta}
          setOpenModalEncuestaSatisfaccion={setOpenModalEncuestaSatisfaccion}
          setOpenModalRespuestaEncuesta={setOpenModalRespuestaEncuesta}
          setEncuestaRespondida={setEncuestaRespondida}
        />
      )}
      {openModalRespuestaEncuesta && tipoRespuesta !== '' && (
        <ModalRespuestaEncuesta
          tipoRespuesta={tipoRespuesta}
          setOpenModalRespuestaEncuesta={setOpenModalRespuestaEncuesta}
          titulo={tipoRespuesta === 'exito' ? properties.encuestaSatisfaccion.exitoTitulo : properties.encuestaSatisfaccion.errorTitulo}
          descripcion={tipoRespuesta === 'exito' ? properties.encuestaSatisfaccion.exitoDescripcion : properties.encuestaSatisfaccion.errorDescripcion}
          botonAccion={tipoRespuesta === 'exito' ? volverACoopeuch : retomarEncuesta}
          botonTexto={tipoRespuesta === 'exito' ? properties.encuestaSatisfaccion.exitoBoton : properties.encuestaSatisfaccion.errorBoton}
        />
      )}
    </>
  );
};
Comprobante.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  activeMenu: PropTypes.number,
  fechaCreacion: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  obtieneScreenshot: PropTypes.func,
};
Comprobante.defaultProps = {
  activeMenu: 5,
  obtieneScreenshot: () => {},
};

export default Screenshot({ nombreArchivo: 'Comprobante' })(Comprobante);
